module.exports = __webpack_public_path__ + "static/media/red.0b3cfde3.jpg";